import { handleFreeShipping } from '../global'

function addCloseIconToLoginModal() {
    $('.login-widget .popup-widget-inner').prepend(`<div class="login-close"></div>`)
    $('.login-close').click(function () {
        $('body').removeClass('login-window-visible user-action-visible')
    })
}
function appendPriceAfterName(cartProduct) {
    const cartProductPrice = cartProduct.find('.cart-widget-product-price')

    cartProduct.find('.cart-widget-product-name').append(cartProductPrice)
}

function getCartWidgetBottomHeight() {
    const cartWidgetBottom = $('#header .cart-widget-bottom')
    const height = cartWidgetBottom.outerHeight(true)
    document.documentElement.style.setProperty('--cart-widget-bottom-height', `${height}px`)
}

function cartWidget() {
    $('.cart-widget-product').each(function () {
        const cartProduct = $(this)

        appendPriceAfterName(cartProduct)
    })
    handleFreeShipping()
    getCartWidgetBottomHeight()
}

export function initPopupWidget() {
    addCloseIconToLoginModal()
    $('.login-widget .popup-widget-inner > h2').text('Anmeldung zum Konto')

    document.addEventListener('ShoptetDOMCartContentLoaded', () => {
        cartWidget()
    })
}
